import { Injectable } from '@angular/core';
import { MarketingCloudPluginService } from '@core/services/native-plugins/salesforce-marketing-cloud.service';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, filter, first } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ContextService } from '../context.service';
import { LogService } from '../log.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsRegistrationService {

  private pushToken$ = new BehaviorSubject<string>(null);

  constructor(
    private mcService: MarketingCloudPluginService,
    private auth: AuthService,
    private ctx: ContextService,
    private log: LogService
  ) {}

  setPushToken(token?: string) {
    this.pushToken$.next(token);
  }

  enableSFMCUserPush() {
    if (!this.ctx.isNativePlatform()) { return; }

    this.auth.getState$().pipe(filter(({ isLogged }) => isLogged), distinctUntilChanged(), first()).subscribe(
      () => {
        this.log.i(this, 'NotificationRegistration. Enabling user push on SFMC');
        // Marketing cloud handles the push token from native
        this.enableUserMarketingCloudPush(this.auth.getState()?.user?.userId);
      }
    );
  }

  disableMarketingCloudUserPush() {
    if (!this.ctx.isNativePlatform()) { return; }
    this.log.i(this, 'NotificationRegistration. Disabling user push on SFMC');
    this.log.i(this, 'Disabling marketing cloud push');
    this.mcService.disablePush();
  }

  private enableUserMarketingCloudPush(marketingUserId?: string) {
    this.log.d(this, `Enabling user marketing cloud push with user id: ${marketingUserId}`);
    if (!marketingUserId) { return; }
    this.mcService.enablePush(marketingUserId);
  }

}
